import { useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { DealService } from '../services';
import { getSessionIdCookie, setSessionIdCookie } from '@utils/Session.utils';
import { useCarDetailsDuck } from '@hooks/useCarDetailsDuck';
import UIDuck from '../redux/commonDucks/ui.duck';
import { ModalVersion, SESSION_COOKIE_NAME } from '../constants/main';
import { useRouter } from 'next/router';
import { getRedirectDestinationOnActivateDeal } from '@utils/Deal.utils';
import { CarDetailsDuck } from '../redux/carDetails/carDetails.duck';
import { useFeatureSwitch } from '@hooks/useFeatureSwitch';
import { useFeatureSwitchEnabled } from '@hooks/useFeatureSwitchEnabled';
import { FEATURES_LIST } from '../context/featureSwitchApp';

const useSessionChangeListener = () => {
    const dispatch = useDispatch();

    const router = useRouter();

    const { currentDeal } = useCarDetailsDuck();

    const { isStockSummaryEnabled, isMTOSummaryEnabled } = useFeatureSwitch();

    const isSessionChangeCheckEnabled = useFeatureSwitchEnabled(
        FEATURES_LIST.FEATURE_SWITCH_CHECK_SESSION_CHANGE_ENABLED
    );

    useEffect(() => {
        document?.addEventListener('visibilitychange', handleTabChange);
    }, []);

    const handleTabChange = () => {
        if (document.visibilityState === 'visible') {
            DealService.currentDeal(getSessionIdCookie()).then(({ data }) => {
                console.log('FETCH TOKEN', data?.token, data?.status);
                console.log('STATE TOKEN', currentDeal.token, currentDeal?.status);

                if (
                    isSessionChangeCheckEnabled &&
                    ((data?.token && currentDeal?.token && data?.token !== currentDeal?.token) ||
                        (data?.status && currentDeal?.status && data?.status !== currentDeal?.status))
                ) {
                    dispatch(
                        UIDuck.openModal({
                            data: {
                                continueWithNewConfiguration: () => {
                                    router.reload();
                                },
                                changeWithPreviousConfiguration: async () => {
                                    const activateRes = await DealService.activateDeal(
                                        currentDeal?.token,
                                        getSessionIdCookie(),
                                        true
                                    );
                                    setSessionIdCookie(activateRes?.headers?.['x-auth-token']);

                                    if (activateRes?.data?.deal) {
                                        batch(() => {
                                            dispatch(CarDetailsDuck.setCurrentDeal(activateRes?.data?.deal));
                                            dispatch(
                                                CarDetailsDuck.setCurrentCarDetails(
                                                    activateRes?.data?.deal?.fullProductConfiguration
                                                )
                                            );
                                        });

                                        const isSummaryEnabled = activateRes?.data?.deal?.fullProductConfiguration.stock
                                            ? isStockSummaryEnabled
                                            : isMTOSummaryEnabled;
                                        const redirectRoute = getRedirectDestinationOnActivateDeal(
                                            activateRes?.data?.deal,
                                            isSummaryEnabled
                                        );
                                        if (redirectRoute) router.push(redirectRoute);
                                    }
                                },
                                newConfiguration: data,
                                previousConfiguration: currentDeal,
                            },
                            modalType: UIDuck.MODAL_TYPES.SESSION_CHANGE,
                            modalVersion: ModalVersion.v2,
                            modalProperties: { centerModeOnDesktop: true },
                        })
                    );
                }
            });
        }
    };
};

export default useSessionChangeListener;
